import ConfirmationMessage from 'components/GlobalModals/SavedForLaterModal/ConfirmationMessage/ConfirmationMessage.f';

export default ConfirmationMessage;
